import React from "react";
import { Pressable, StyleSheet } from "react-native";
import { View, Text } from "../../../components/Themed";
import Colors from "../../../constants/Colors";
import { Feather } from "@expo/vector-icons";

export const RefreshButton = ({ isFetching, getAttendees, pingTime }) => (
  <View style={styles.refreshButtonContainer}>
    <Pressable
      style={{
        flexDirection: "row",
        alignItems: "center",
        paddingHorizontal: 16,
        paddingVertical: 8,
        borderRadius: 8,
        gap: 8,
      }}
      onPress={async () => {
        await getAttendees();
      }}
      disabled={isFetching || pingTime === null}
    >
      {pingTime !== null && (
        <Feather name="rotate-cw" size={16} color={Colors.nuetral_grey_600} />
      )}
      <Text
        size={16}
        lightColor={Colors.nuetral_grey_600}
        style={{
          textAlign: "center",
          fontFamily: "NunitoBold",
        }}
      >
        {pingTime === null
          ? "You're Offline - Connect To Refresh"
          : isFetching
          ? "Refreshing..."
          : "Refresh"}
      </Text>
    </Pressable>
  </View>
);

const styles = StyleSheet.create({
  refreshButtonContainer: {
    width: "100%",
    paddingTop: 24,
    paddingBottom: 32,
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: Colors.base_colors_white,
  },
});
